module.exports = __webpack_public_path__ + "img/presse-christophe-de-barry.a882bafc.jpg";